import { Toaster } from 'sonner';
import { useApplyTheme } from '@/hooks/useApplyTheme';

/**
 * Owns the live theme (writes `<html data-theme>` via `useApplyTheme`) and
 * renders the toast portal with a matching theme. Single mount point for the
 * theme effect — mount once near the app root.
 */
export function AppChrome() {
  const theme = useApplyTheme();
  return <Toaster theme={theme} richColors closeButton position="top-right" />;
}
